// extracted by mini-css-extract-plugin
export default {"submitItem":"MetaProgramManagerCompanyMisc_submitItem__ESO1S"};